/**
 * Remove undefined props
 *
 * @export
 * @param {*} props
 * @returns
 */
export default function refactorProps(props: any) {
    const keys: string[] = Object.keys(props);
    for (let i: number = 0; i < keys.length; i++) {
        if (typeof props[keys[i]] === "undefined") {
            delete props[keys[i]];
        }
    }
    return props;
}
